module.exports = __webpack_public_path__ + "img/ch63.8160b3df.png";